<template>
  <div class="c-main">
    <div
      class="banner"
      :style="{
        backgroundImage: `url('${BASE_URL}${newHeader.url}')`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
      }"
    >
      <div class="banner-container">
        <h1 class="banner-title">新闻动态</h1>
        <div class="banner-desc" v-html="newHeader.content"></div>
      </div>
      <div class="breadcrumb">
        <span @click="$router.push('/')">首页</span>
        <span class="separator">/</span>
        <span>新闻动态</span>
        <span class="separator">/</span>
        <span>企业动态</span>
      </div>
    </div>
    <div class="news-page">
      <!-- 标签导航 -->
      <div class="tab-nav">
        <span
          v-for="(tab, index) in tabList"
          :key="index"
          :class="['tab-item', { active: currentTab === index }]"
          @click="handleTabChange(index, tab.type)"
        >
          {{ tab.label }}
        </span>
      </div>
      <div style="background-color: #f7f8fc">
        <div style="height: 40px"></div>
        <!-- 新闻列表 -->
        <div class="news-list">
          <div
            class="news-card"
            v-for="(news, index) in newsList"
            :key="news.id"
            :class="{ active: isFirstActive(index) }"
            @click="goToDetail(news)"
          >
            <img
              :src="BASE_URL + news.infoImage"
              class="news-img"
              loading="lazy"
            />
            <h3 class="news-title">{{ news.infoTitle }}</h3>
            <div class="news-meta">
              <span class="date">{{
                news.createDate.split(" ")[0] || ""
              }}</span>
              <span class="detail">查看详情 →</span>
            </div>
          </div>
        </div>
        <!-- 分页组件（Element UI） -->
        <div class="pagination-container">
          <el-pagination
            @current-change="handlePageChange"
            :current-page="currentPage"
            :page-size="pageSize"
            :total="totalCount"
            layout="prev, pager, next, jumper"
            background
            :disabled="isLoading"
          ></el-pagination>
        </div>
        <div style="height: 40px"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { listInfo, getConf } from "../../api/article";
// import ArticleItem from "../Components/ArticleItem";

export default {
  name: "productCenter",
  data() {
    return {
      BASE_URL: process.env.VUE_APP_API_BASE_URL,
      newHeader: {},
      currentTab: 0, // 当前标签索引
      currentPage: 1, // 当前页码
      pageSize: 8, // 每页显示8条
      isLoading: false, // 加载状态
      totalCount: 0, // 总数据量（接口返回）
      newsList: [], // 接口返回的新闻列表
      allNews: [], // 存储所有新闻数据用于前端分页
      currentInfoType: 1, // 当前选中的资讯类型（默认1=企业动态）
      tabList: [
        { label: "企业动态", type: 1 }, // 对应 infoType=1
        { label: "行业资讯", type: 2 }, // 对应 infoType=2
        { label: "媒体报道", type: 3 }, // 对应 infoType=3
      ],
    };
  },
  //  filters: {
  //   setText(val) {
  //     return val
  //       .replace(/<(p|div)[^>]*>(<br\/?>|&nbsp;)<\/\1>/gi, "\n")
  //       .replace(/<br\/?>/gi, "\n")
  //       .replace(/<[^>/]+>/g, "")
  //       .replace(/(\n)?<\/([^>]+)>/g, "")
  //       .replace(/\u00a0/g, " ")
  //       .replace(/&nbsp;/g, " ")
  //       .replace(/<img[^>]+src\\s*=\\s*['\"]([^'\"]+)['\"][^>]*>/g, "")
  //       .replace(/<\/?(img|table)[^>]*>/g, "") // 去除图片和表格
  //       .replace(/<\/?(a)[^>]*>/g, ""); //  去除a标签
  //   },
  // },
  computed: {
    // 分页后的数据
    paginatedNews() {
      return this.newsList;
    },
  },
  created() {},
  mounted() {
    this.fetchHomeConf();
    this.fetchNewsData();
  },
  methods: {
    async fetchHomeConf() {
      try {
        const response = await getConf();
        this.newHeader = JSON.parse(response.data.newHeader) || {};
      } catch (error) {
        console.error("页面初始化获取配置失败", error);
      }
    },
    handleTabChange(index, type) {
      if (this.currentTab === index) return; // 新增：防重复点击
      this.currentTab = index;
      this.currentInfoType = type;
      this.currentPage = 1;
      this.fetchNewsData(); // 仍调用原有方法
    },
    // 判断是否为第一页第一条数据（高亮）
    isFirstActive(index) {
      return this.currentTab === 0 && this.currentPage === 1 && index === 0;
    },

    // 切换标签
    switchTab(index) {
      if (this.currentTab === index) return; // 防止重复点击
      this.currentTab = index;
      this.currentPage = 1; // 切换标签重置页码
      this.fetchNewsData(); // 重新请求数据
    },

    // 页码变化
    handlePageChange(page) {
      this.currentPage = page;
      // 关键修改：替换原 fetchNewsData，直接前端拆分
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      this.newsList = this.allNews.slice(start, end);
      window.scrollTo({ top: 0, behavior: "smooth" });
    },

    // 跳转到详情页
    goToDetail(news) {
      this.$router.push({ path: `/newdetails/${news.infoId}` , query: { type: 'news', }  });
    },
    async fetchNewsData() {
      try {
        this.isLoading = true;
        const requestParams = {
          pageNum: 1,
          numPerPage: 999,
        };
        const res = await listInfo(requestParams, {
          infoType: this.currentInfoType,
        });
        if (res.code == 0) {
          this.allNews = res.rows; // 存储所有数据（10条）
          this.totalCount = res.total;
          // 新增：调用前端分页拆分
          const start = (this.currentPage - 1) * this.pageSize;
          const end = start + this.pageSize;
          this.newsList = this.allNews.slice(start, end);
          this.totalCount = res.total;
        } else {
          this.allNews = [];
          this.newsList = [];
          this.totalCount = 0;
          this.$message.warning("未获取到新闻数据");
        }
      } catch (error) {
        console.error("新闻数据请求失败：", error);
        this.$message.error("网络异常，请稍后重试");
        this.allNews = [];
        this.newsList = [];
        this.totalCount = 0;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin backgroundImage($url) {
  background-image: url($url);
  background-repeat: no-repeat;
  background-size: 100%;
}

.c-main {
  min-height: calc(100vh - 100px);
}
.banner {
  width: 100%;
  height: 450px;
  position: relative;
  .banner-container {
    position: absolute;
    left: 300px; // 距离左侧边距
    top: 177px;
    transform: translateY(-50%);
    color: #fff;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    .banner-title {
      font-size: 48px;
      font-weight: bold;
      margin: 0 0 20px;
      line-height: 1.2;
    }

    .banner-desc {
      font-size: 16px;
      margin: 0 0 16px;
      opacity: 0.9;
      max-width: 1200px;
    }
  }
  .breadcrumb {
    position: absolute;
    left: 300px; // 距离左侧边距
    bottom: 24px;
    font-size: 12px;
    opacity: 0.8;
    display: flex;
    align-items: center;
    gap: 8px;
    color: #fff;
    span {
      cursor: pointer;
      &:hover {
        opacity: 1;
      }
    }

    .separator {
      cursor: default;
      opacity: 0.6;
    }
  }
}
.news-page {
}

// 标签导航样式
.tab-nav {
  display: flex;
  justify-content: center;
  gap: 30px;
  background: linear-gradient(
    180deg,
    #ffffff 0%,
    #f5f9ff 0%,
    #f9fcff 43%,
    #ffffff 100%
  );
  border-radius: 0px 0px 0px 0px;
  height: 60px;
  align-items: center;

  .tab-item {
    font-size: 16px;
    color: #666;
    cursor: pointer;
    padding: 5px 0;
    position: relative;
    transition: color 0.3s;

    &:hover {
      color: #005cef;
    }

    &.active {
      color: #005cef;
      font-weight: bold;

      &::after {
        content: "";
        position: absolute;
        bottom: -11px; // 对齐底部边框
        left: 0;
        width: 100%;
        height: 2px;
        background-color: #005cef;
      }
    }
  }
}

// 新闻列表样式
.news-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  max-width: 1200px;
  margin: 0 auto 40px;
}

// 新闻卡片样式
.news-card {
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  cursor: pointer;

  &.active {
    border: 2px solid #005cef;
  }

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
  }

  .news-img {
    width: 100%;
    height: 200px;
    object-fit: cover;
    transition: transform 0.5s ease;

    &:hover {
      transform: scale(1.05);
    }
  }

  .news-title {
    font-size: 18px;
    color: #000a25;
    padding: 16px;
    margin: 0;
    line-height: 1.4;
  }

  .news-meta {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px 16px;

    .date {
      font-size: 14px;
      color: #999;
    }

    .detail {
      font-size: 14px;
      color: #005cef;
      display: flex;
      align-items: center;
      gap: 4px;
    }
  }
}

// 分页容器样式
.pagination-container {
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
}

// Element UI分页组件样式调整
::v-deep .el-pagination {
  padding-top: 20px;

  .el-pagination__button {
    border-radius: 4px;
  }

  .el-pagination__active {
    background-color: #005cef;
    border-color: #005cef;
  }

  .el-pager li {
    margin: 0 5px;
  }
}
</style>
